// export either window or global
export var safeGlobal = typeof global === "undefined" ? window : global;
//# sourceMappingURL=safe-global.js.map